import { html, css, LitElement } from "lit";
import { customElement } from "lit/decorators.js";

@customElement("loading-spinner")
export class LoadingSpinner extends LitElement {
	static styles = css`
		.progress {
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
		}
		/* Thanks, https://loading.io/css/ */
		.lds-dual-ring {
			display: inline-block;
			width: 80px;
			height: 80px;
		}
		.lds-dual-ring:after {
			content: " ";
			display: block;
			width: 64px;
			height: 64px;
			margin: 8px;
			border-radius: 50%;
			border: 6px solid #000;
			border-color: #000 transparent #000 transparent;
			animation: lds-dual-ring 1.2s linear infinite;
		}
		@keyframes lds-dual-ring {
			0% {
				transform: rotate(0deg);
			}
			100% {
				transform: rotate(360deg);
			}
		}
	`;

	render() {
		return html`
			<div class="lds-dual-ring progress"></div>
		`;
	}
}